module.exports = __webpack_public_path__ + "img/Teams.97218b9f.svg";